import { translateColumns } from "../../../../../utils/tableUtils";

import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { Pagination, PaginationProps, Table, TableColumnsType } from "antd";

import { get, set } from "lodash";
import { useParams } from "react-router-dom";
import moment from "moment";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import "./DetailConfirm.scss";
import { postHistoryApproval } from "../../../../../service/course-plan-managment/mooc-approval-plan/mooc-approval-plan-api";
import { OrganizationalGroupId } from "../../constants/data";
const DetailConfirm = () => {
  const { t } = useTranslation();
  const [listApproval, setListApproval] = useState<any[]>([]);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const params = useParams();
  const getlistData = () => {
    setLoading(true);
    const data = {
      pageNumber: pageNumber,
      pageSize: pageSize,
    };
    console.log(get(params, "id", ""))
    postHistoryApproval(get(params, "id", ""), data)
      .then((res) => {
        const { data } = res.data;
        setListApproval(data.data);
        setTotalRecords(data.totalRecords);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };
  useEffect(() => {
    getlistData();
  }, [pageNumber, pageSize]);
  const dataColumns: TableColumnsType<any> = [
    {
      title: "STT",
      width: 2,
      render: (_: any, record, index: number) => {
        const orderNumber = (index + 1).toString().padStart(2, "0");
        return <span className="table-order-header">{orderNumber}</span>;
      },
    },
    {
      title: t("Tên cán bộ duyệt", "Tên cán bộ duyệt"),
      width: 10,
      render: (_, record: Record<string, any>) => {
        const values = Object.values(record) as {
          userName: string;
          groupName: string;
          nameLeader: string;
          nameMember: string;
          organizationalGroupId: number;
        }[];
        let positionName: string = t("Chủ trì", "Chủ trì");
        if (values[0].organizationalGroupId === OrganizationalGroupId.TCM) {
          positionName = t("Tổ trưởng", "Tổ trưởng");
        }
        if (values[0].organizationalGroupId === OrganizationalGroupId.HDTM) {
          positionName = t("Chủ tịch HĐ", "Chủ tịch HĐ");
        }
        return (
          <>
            {values[0].userName ?? values[0].groupName}
            {values[0].groupName && (
              <>
                {values[0].nameLeader && (
                  <>
                    <br />
                    {positionName}: {values[0].nameLeader}
                  </>
                )}
                {values[0].nameMember && (
                  <>
                    <br />{t("Thành viên:", "Thành viên:")} {values[0].nameMember}</>
                )}
              </>
            )}
          </>

        );
      },
    },
    {
      title: t("Thời gian", "Thời gian"),
      width: 6,
      render: (_, record) => {
        const formattedTime = (time: string) => moment(time).format("HH:mm:ss");
        const formattedDate = (date: string) =>
          moment(date).format("DD/MM/YYYY");
        const times = Object.values<any>(record).map((item) => (
          <div key={item.id} style={{ marginBottom: "8px" }}>
            {formattedTime(item.approvalDate)} <br />
            {formattedDate(item.approvalDate)}
          </div>
        ));
        return times;
      },
    },
    {
      title: t("Trạng thái", "Trạng thái"),
      width: 6,
      render: (_: any, record) => {
        const times = Object.values<any>(record).map((item, index, array) => (
          <div
            key={item.id}
            className="table-status"
            style={{
              marginBottom: index !== array.length - 1 ? "28px" : "0",
              marginTop: index !== 0 ? "28px" : "0",
            }}
          >
            <div
              className="color-icon"
              style={{
                backgroundColor:
                  item.constructionPlanStatus === 2 ? "#52C41A" : "red",
              }}
            ></div>
            {item.constructionPlanStatus === 2 ? t("Đồng ý", "Đồng ý") : t("Không đồng ý", "Không đồng ý")}
          </div>
        ));
        return times;
      },
    },
    {
      title: t("Mô tả", "Mô tả"),
      width: 9,
      render: (_, record) => {
        const times = Object.values<any>(record).map((item, index, array) => (
          <div
            key={item.id}
            style={{
              marginBottom: index !== array.length - 1 ? "28px" : "0",
              marginTop: index !== 0 ? "28px" : "0",
            }}
          >
            {item.approvalRemark === "" || item.approvalRemark == null ? (
              t("Không có ý kiến nhận xét", "Không có ý kiến nhận xét")
            ) : (
              <div dangerouslySetInnerHTML={{ __html: item.approvalRemark }} />
            )}
          </div>
        ));
        return times;
      },
    },
  ];
  const onChange: PaginationProps["onChange"] = (page, pageSize) => {
    if (setPageNumber && setPageSize) {
      setPageNumber(page);
      setPageSize(pageSize);
    }
  };
  const itemRender: PaginationProps["itemRender"] = (
    _,
    type,
    originalElement
  ) => {
    if (type === "prev") {
      return <LeftOutlined />;
    }
    if (type === "next") {
      return <RightOutlined />;
    }
    return originalElement;
  };
  return (
    <>
      <div className="table-wrapper">
        <Table
          size="middle"
          tableLayout="fixed"
          pagination={false}
          columns={translateColumns(dataColumns, t)}
          dataSource={listApproval}
          scroll={{ y: 600 }}
          loading={loading}
        />
        <Pagination
          total={totalRecords}
          showSizeChanger
          pageSize={pageSize}
          current={pageNumber}
          className="pagination-table"
          onChange={onChange}
          itemRender={itemRender}
          locale={{
            items_per_page: t("/ trang", "/ trang"),
            jump_to: t("Đi đến trang", "Đi đến trang"),
            page: "",
          }}
          showQuickJumper
          showTotal={(total) => `${t("Tổng số", "Tổng số")} ${total} ${t("bản ghi", "bản ghi")}`}
        />
      </div>
    </>
  );
};

export default DetailConfirm;
